import {Component, ViewChild} from '@angular/core';
import {StepScreenModel} from '../../../shared/step/step-screen.component';
import {FormErrors} from '../../../../components/forms/validation/form-validator.class';
import {NgForm} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {LanguageService} from '../../../../domain/model/info/language/language.service';
import {PracticeSpecialtyService} from '../../../../domain/model/info/practicespecialty/practice-specialty.service';
import {PersonalDetailsSectionService} from '../../model/personal-details-section.service';
import {BasicInfo} from '../../model/basic-info.model';
import {Roles} from '../../../../domain/authorization/roles';
import {AuthService} from '../../../../components/security/authorization/auth.service';

@Component({
    template: require('./basic-info-screen.component.html'),
    styles: [require('./basic-info-screen.component.scss')],
})
export class BasicInfoScreenComponent {

    constructor(readonly personalDetailsService: PersonalDetailsSectionService,
                readonly languageService: LanguageService,
                readonly practiceSpecialtyService: PracticeSpecialtyService,
                private _authService: AuthService) {
        this.practiceSpecialtyService.getPracticeSpecialties().subscribe(
            specialties => this.practiceSpecialties = specialties.map(s => s.name)
        );
        this.languageService.getLanguages().subscribe(languages => this.languages = languages.map(l => l.name));
        this._authService.user$.take(1).subscribe(user => {
            if (user && user.hasAnyRole([Roles.ADMIN])) {
                this.readonly = false;
            }
        });
    }

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    readonly: boolean = true;

    practiceSpecialties: Array<string> = [];
    languages: Array<string> = [];

    stepScreenModel = new StepScreenModel<BasicInfo>({
        initialDataModel: new BasicInfo(),
        specificValidationMessages: {},
        _loadDataFn: () => {
            return this.personalDetailsService.currentUserBasicInfo();
        },
        _submitDataFn: (model: BasicInfo) => {
            return this.personalDetailsService.updateCurrentUserBasicInfo(model);
        }
    });

    get model(): BasicInfo {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/personal-details/steps/basic-info/basic-info-screen.component.ts